import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import RewardClaimHistoryTable, {
  tableColumns
} from 'components/tables/RewardClaimHistoryTable';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const RewardClaimTransactionList = () => {
  const nav = useNavigate();
  const [rewardClaims, setRewardClaims] = useState([]);
  const token = localStorage.getItem('token');
  const [statusFilter, setStatusFilter] = useState('pending');
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    getList();
  }, [statusFilter, pagination]);

  const getList = async () => {
    const params: Record<string, any> = {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize
    };
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/transaction/reward-claim`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: params
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setRewardClaims(response.data['data']['rewardClaims']);
    setTotalRecords(response.data['data']['totalRecords']);
  };
  const handlePaginationChange = (updater: any) => {
    const newState =
      typeof updater === 'function' ? updater(pagination) : updater;
    setPagination(newState);
  };
  const table = useAdvanceTable({
    data: rewardClaims,
    columns: tableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      manualPagination: true,
      totalRecords: totalRecords,
      onPaginationChange: handlePaginationChange,
      pagination: pagination,
      getList: getList
    }
  });

  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <h2 className="mb-0">{totalRecords} Claim Records</h2>
            </Col>
            <Col xs="auto"></Col>
          </Row>
          <RewardClaimHistoryTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default RewardClaimTransactionList;
